import CustomerFrequencyCard from './CustomerFrequencyCard';
import WeeklyDynamicsItem from './WeeklyDynamicsItem';
import WeeklyStatsCard from './WeeklyStatsCard';

export default {
  CustomerFrequencyCard,
  WeeklyDynamicsItem,
  WeeklyStatsCard,
};
